import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { UserOnboardingViewHubsModule } from './user-onboarding-view-hubs/user-onboarding-view-hubs.module';
import { GroupMatchConfigStoreModule } from '@libs/src/group-match-config/group-match-config-store.module';
import { GroupMembershipPipeModule } from '@main-client/src/app/pipes/group-membership-pipe/group-membership-pipe.module';
import { UserOnboardingSuccessDialogModule } from '@main-client/src/app/user-onboarding/user-onboard-success-dialog/user-onboarding-success-dialog.module';
import { UserOnboardingHubPreferencesDialogModule } from '@main-client/src/app/user-onboarding/user-onboarding-hub-preferences-dialog/user-onboarding-hub-preferences-dialog.module';
import { UserOnboardingHubPreferencesViewModule } from '@main-client/src/app/user-onboarding/user-onboarding-hub-preferences-view/user-onboarding-hub-preferences-view.module';
import { UserOnboardingViewGoalSettingModule } from '@main-client/src/app/user-onboarding/user-onboarding-view-goal-setting/user-onboarding-view-goal-setting.module';
import { UserOnboardingViewIntroGoalsSelectionModule } from '@main-client/src/app/user-onboarding/user-onboarding-view-intro-goals-selection/user-onboarding-view-intro-goals-selection.module';

import { AccountBackend } from '@libs/src/account/account.backend';
import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { AuthGuardService } from '@main-client/src/app/core/auth-guard.service';
import { UserOnboardingService } from '@main-client/src/app/user-onboarding/user-onboarding.service';

import { UserOnboardingComponent } from './user-onboarding.component';

import { ActiveUserGuard } from '@main-client/src/app/core/active-user.guard';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    GroupMatchConfigStoreModule,
    GroupMembershipPipeModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    UserOnboardingHubPreferencesDialogModule,
    UserOnboardingViewIntroGoalsSelectionModule,
    UserOnboardingHubPreferencesViewModule,
    UserOnboardingSuccessDialogModule,
    UserOnboardingViewHubsModule,
    UserOnboardingViewGoalSettingModule,
  ],
  providers: [
    AccountBackend,
    AuthGuardService,
    ActiveUserGuard,
    GroupsBackend,
    UserOnboardingService,
  ],
  declarations: [UserOnboardingComponent],
  exports: [UserOnboardingComponent],
})
export class UserOnboardingModule {}
